import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import PBFormRender from './PBFormRender'
import { formFieldsOptions } from './common.js'
import { loadInitialValue } from './actions/index.js'

class PageBuilderForm extends Component {


  render(){
    const { handleSubmit, state, showButtons } = this.props

    var addonOps = formFieldsOptions( state.sppbForm.mainForm )

    var formClass = 'form settings-form';
    if ( state.sppbForm.form == 'insideForm' ) {
      formClass += ' no-display';
    }

    return(
      <form
        className={formClass}
        onSubmit={ handleSubmit }
        >
        <div id="sp-pagebuilder-modal-top-actions" className="sp-modal-top-action-btns">
          {
            showButtons &&
            <div>
              <button type="submit" className="sp-pagebuilder-btn sp-pagebuilder-btn-success">
                <i className="fa fa-check-square-o"></i><i className="fa fa-circle-o-notch fa-spin"></i> Apply
              </button>
            </div>
          }
          
        </div>
        <PBFormRender addonOps={ addonOps } formName="mainForm" />
      </form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    initialValues: state.sppbForm.mainForm.values
  };
}

PageBuilderForm = reduxForm({
  form: 'sppbForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(PageBuilderForm);

PageBuilderForm = connect(
  mapStateToProps
)(PageBuilderForm);

export default PageBuilderForm;



// WEBPACK FOOTER //
// ./src/helpers/form/PageBuilderForm.js